import axios from "axios";
import { API_ENDPOINTS } from "../config/api";

const TOKEN_STORAGE_KEY = "token";
export const MESSAGES_ENDPOINT = API_ENDPOINTS.messages;

export const getAuthToken = () => localStorage.getItem(TOKEN_STORAGE_KEY);

export const isAuthenticated = () => Boolean(getAuthToken());

export const persistAuthToken = (token) => {
  localStorage.setItem(TOKEN_STORAGE_KEY, token);
  window.dispatchEvent(new Event("auth-changed"));
};

export const clearAuthToken = () => {
  localStorage.removeItem(TOKEN_STORAGE_KEY);
  window.dispatchEvent(new Event("auth-changed"));
};

export const fetchMessages = async (token) => {
  const response = await axios.get(MESSAGES_ENDPOINT, {
    headers: {
      Authorization: `Bearer ${token}`,
    },
  });

  return response.data;
};
